<template>
  <div
    class="indexs fcc"
    id="app1"
    :style="{ backgroundImage: 'url(' + bgImgUrl + ')' }"
  >
    <div class="frcs top">
      <div class="left fcc">
        <img :src="maxInfo.img" style="object-fit: cover" />
        第{{ maxInfo.chinese_number }}轮
        <div class="name">奖品名称{{ maxInfo.award_name }}</div>
        <div class="number">共 {{ maxInfo.draw_number }} 份</div>
      </div>

      <!-- 开始抽奖前 -->
      <div class="right cc" v-if="state == 1">
        <div class="fcc">
          <button
            class="openBot2 cc"
            @click="rollName2"
            @keyup.enter="handleEnter($event)"
          >
            开始抽奖
          </button>

          <div class="tis">鼠标点击或者按回车键开始抽奖</div>
        </div>
      </div>

      <!-- 倒计时 -->
      <div
        class="right fcc"
        style="background-color: #d4cebd"
        v-if="state == 2"
      >
        <div class="ready">即将开始自动抽奖</div>
        <div class="num">{{ number }}</div>
        <div class="stop" @click="stop3">暂停</div>
      </div>

      <!-- 抽奖轮播名单 -->
      <div class="right fcc" v-if="state == 3">
        <div class="cjing">自动抽奖中</div>
        <div
          class="wrap-container sn-container"
          style="width: 100%; height: 100%; overflow: hidden"
        >
          <div class="sn-content" style="width: 100%; height: 100%">
            <div class="sn-body" style="width: 100%; height: 100%">
              <div class="wrap-container" style="width: 100%; height: 100%">
                <div class="table" style="width: 100%; height: 100%">
                  <vue-seamless-scroll
                    :data="listData"
                    :class-option="
                      i == 1 || i == 3 ? optionSettingFast : optionSetting
                    "
                    v-for="(item, i) in listData"
                    :key="i"
                    class="seamless-warp"
                    :id="i"
                    style="width: 100%; height: 100%"
                  >
                    <table
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      class="item"
                      style="width: 100%"
                    >
                      <tbody>
                        <tr
                          class="labelIndex"
                          v-for="(childItem, childIndex) in item"
                          :key="childIndex"
                        >
                          <td>
                            <div>{{ childItem.name }}</div>
                            <div>{{ childItem.phone }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中奖名单 -->
      <div
        class="right fcc"
        v-if="state == 4"
        style="background-color: #ec493b; color: #fdc976"
      >
        <div class="congrats" style="color: #fdc976">恭喜中奖</div>
        <div class="next" v-if="maxInfo.next_id != 0" @click="getNext">
          下一轮抽奖
        </div>
        <!-- 名单大于5 -->
        <div v-if="drawList.length > 5" style="padding-top: 30px">
          <div class="cbox frc" style="flex-wrap: wrap">
            <div
              class="csma fcc"
              v-for="(item, index) in drawList"
              :key="index"
            >
              {{ item.name }}
              <div>{{ item.phone }}</div>
            </div>
          </div>
        </div>
        <!-- 名单小于5 -->
        <div class="cbox cc" v-else style="padding-top: 18vh">
          <div
            class="csma fcc"
            :style="{ 'font-size': nnu + 'px' }"
            v-for="(item, index) in drawList"
            :key="index"
          >
            {{ item.name }}
            <div>{{ item.phone }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="bot" v-if="maxInfo2.length == 0">
      <img class="img3" src="/static/imgs/img2.png" />
    </div>

    <div class="frcs gud">
      此服务由小程序「微购会」提供技术支持
      <div class="frc">
        <img class="img4" src="/static/imgs/img3.png" />
        <div class="set1 cc" @click="goBack">返回首页</div>
        <div class="set1 cc">更换背景</div>
        <div class="setImg">
          <upload-img ref="uploadimg" @transmit="getMessage"></upload-img>
        </div>
        <div class="set1 cc" @click="openAudio">
          {{ isplaying == true ? "关闭音效" : "开启音效" }}
        </div>
        <div class="set1 cc" @click="setlun">选择轮次</div>
        <el-button
          class="set1 cc"
          style="
            background: none;
            color: #fcc876;
            border: 1px solid #fcc876;
            font-size: 16px;
            margin-left: 10px;
            display: flex;
          "
          v-if="!fullscreen"
          @click="fullScreen()"
          >全屏显示</el-button
        >
        <el-button
          class="set1 cc"
          style="
            background: none;
            color: #fcc876;
            border: 1px solid #fcc876;
            font-size: 16px;
            margin-left: 10px;
            display: flex;
          "
          v-else
          @click="exitFullscreen()"
          >退出全屏</el-button
        >
      </div>
    </div>

    <!-- 查看弹窗 -->
    <div
      :class="show == false ? 'zhe dis_none' : 'zhe'"
      @click="zheclick"
    ></div>
    <div :class="show == false ? 'zheBox dis_none' : 'zheBox'">
      <div class="ztit">选择轮次</div>
      <div class="frcs zbox" v-for="(item, index) in awardList">
        <div class="frc">
          <img :src="item.img" />
          <div class="fc">
            <div
              style="text-align: left; margin-bottom: 6px; font-weight: bold"
            >
              {{ item.award_name }}
            </div>
            <div style="text-align: left">第{{ item.chinese_number }}轮</div>
          </div>
        </div>
        <div
          class="zxh"
          @click="onNum"
          :data-ty="item.open_status"
          :data-id="item.id"
        >
          {{ item.open_status == 1 ? "展示名单" : "进入抽奖" }}
        </div>
      </div>
    </div>
    <div>
      <!-- 音频播放 -->
      <audio ref="audio" style="opacity: 0">
        <source src="/static/audio/背景音乐.MP3" loop />
      </audio>
      <audio ref="audio1" style="opacity: 0; z-index: 0">
        <source src="/static/audio/倒计时音效.flac" />
      </audio>
      <audio ref="audio2" style="opacity: 0; z-index: 0">
        <source src="/static/audio/抽奖中音效.mp3" />
      </audio>
      <audio ref="audio3" style="opacity: 0; z-index: 0">
        <source src="/static/audio/名单展示.mp3" loop />
      </audio>
      <audio ref="audio4" style="opacity: 0; z-index: 0">
        <source src="/static/audio/开奖音乐.mp3" />
      </audio>
      <!-- 音频播放 结束-->
    </div>
  </div>
</template>
  <script>
import vueSeamlessScroll from "vue-seamless-scroll";
import uploadImg from "../components/uploadImg.vue";
export default {
  // components: { uploadImg },
  name: "seamless-scroll",
  components: {
    vueSeamlessScroll,
    uploadImg,
  },
  data() {
    return {
      // 数据
      listData: [],
      dList: [],
      pageNo: 1, //页码
      totalPage: 0, //总共页数
      drawList: [], //中奖名单
      createTimer: null, //定时器
      show: false,
      state: 1,
      id: "",
      number: 5,
      nnu: "",
      // stop2: 0,
      maxInfo: "",
      fullscreen: false,
      isplaying: true,
      maxInfo2: "",
      bgImgUrl:
        " background-image: linear-gradient(to bottom, #d93326, #ff5f52)",
    };
  },
  computed: {
    optionSetting() {
      return {
        step: 8, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 0, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    optionSettingFast() {
      return {
        step: 12, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    // 背景音乐
    openAudio() {
      if (this.isplaying == false) {
        this.isplaying = true;
        this.$refs.audio3.play();
        this.bgmXun = setInterval(() => {
          this.$refs.audio3.play();
        }, 20000);
      } else {
        clearInterval(this.bgmXun);
        this.isplaying = false;
        this.$refs.audio.pause();
        this.$refs.audio1.pause();
        this.$refs.audio2.pause();
        this.$refs.audio3.pause();
        this.$refs.audio4.pause();
      }
    },

    getMessage(id) {
      this.drawIndex();
    },

    // 返回首页
    goBack() {
      this.$router.go(-1);
    },

    // 全屏功能
    fullScreen() {
      //全屏
      var full = document.body || document.documentElement;
      this.fullscreenFn(full);
      this.fullscreen = true;
    },
    exitFullscreen() {
      // 退出全屏
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      this.fullscreen = false;
    },
    fullscreenFn(element) {
      // 全屏
      if (element.requestFullscreen) element.requestFullscreen();
      else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
      else if (element.webkitRequestFullscreen)
        element.webkitRequestFullscreen();
      else if (element.msRequestFullscreen) element.msRequestFullscreen();
    },

    // 获取页面信息
    drawIndex() {
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
        id: this.id,
      };
      this.$get(this.$axios.defaults.orURL + "/index/drawIndex", param).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.web_img.length > 0) {
              this.bgImgUrl = res.data.web_img;
            }
            this.maxInfo2 = res.data.web_img;
            if (res.data.end_status == 0) {
              this.listData = res.data.apply_list;
              this.maxInfo = res.data;
              // 判断开奖状态
              this.id = res.data.id;
              // 未开奖
              if (res.data.open_status == 0) {
                this.$refs.audio.play();
                this.bgmXun = setInterval(() => {
                  this.$refs.audio.play();
                }, 20000);
                this.state = 1;
              } else {
                if (this.isplaying == true) {
                  this.$refs.audio3.play();
                  this.bgmXun = setInterval(() => {
                    this.$refs.audio3.play();
                  }, 20000);
                }
                // 已开奖
                this.state = 4;
                //中奖名单分页
                console.log(res.data.draw_list);
                this.dList = res.data.draw_list;
                this.nnu = 30 - res.data.draw_list.length * 2;
                this.drawList = res.data.draw_list.slice(0, 30); //计算一共多少页
                this.totalPage = Math.ceil(res.data.draw_list.length / 30); //创建定时器，三秒钟循环一次
                this.createTimer = setInterval(() => {
                  this.changeList();
                }, 5000);
              }
            } else {
              this.$router.go(-1);
            }
          }
        }
      );
    },

    // 点击选择轮次
    onNum(e) {
      var ty = e.target.dataset.ty;
      this.id = e.target.dataset.id;
      if (ty == 0) {
        this.show = false;
        this.state = 1;
        this.drawIndex();
      } else {
        this.dList = [];
        this.drawList = [];
        this.totalPage = 0;
        this.pageNo = 1;
        clearInterval(this.createTimer);
        this.show = false;
        this.state = 4;
        this.drawIndex();
      }
    },

    // 下一轮抽奖
    getNext() {
      this.id = this.maxInfo.next_id;
      this.drawIndex();
    },

    // 中奖名单分页
    changeList() {
      //判断当前页是不是最后一页
      if (this.totalPage == this.pageNo) {
        this.pageNo = 1;
        this.drawList = this.dList.slice(0, 30);
      } else {
        this.pageNo++;
        this.drawList = this.dList.slice(
          (this.pageNo - 1) * 30,
          this.pageNo * 30
        );
      }
    },

    // 奖品列表 弹窗
    setlun() {
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
      };
      this.$get(this.$axios.defaults.orURL + "/index/awardList", param).then(
        (res) => {
          if (res.code == 1) {
            this.awardList = res.data;
            this.show = true;
          }
        }
      );
    },

    zheclick() {
      this.show = false;
    },

    //回车开始抽奖
    handleEnter(e) {
      if (e.key == "Enter") {
        this.rollName2();
      }
    },

    //抽奖 倒计时
    rollName2() {
      clearInterval(this.bgmXun);
      this.$refs.audio.pause();
      // 检测是否可以抽奖
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
        id: this.id,
      };
      this.$get(this.$axios.defaults.orURL + "/index/checkDraw", param).then(
        (res) => {
          if (res.code == 1) {
            // 开始倒计时音乐
            this.$refs.audio1.currentTime = 0;
            this.$refs.audio1.play();
            this.state = 2;

            this.dao = setInterval(() => {
              this.jian();
            }, 1000);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "warning",
            });
          }
        }
      );
    },

    // 倒计时
    jian() {
      if (this.number >= 1) {
        this.number = this.number - 1;
      } else {
        // 倒计时结束
        clearInterval(this.dao);
        // 结束倒计时音乐
        this.$refs.audio1.pause();
        // 抽奖中音乐
        this.$refs.audio2.play();
        this.state = 3;
        // 抽奖名单
        let count = Math.ceil(this.listData.length / 5);
        let newList = [];
        for (let i = 0; i < this.listData.length; i += count) {
          newList.push(this.listData.slice(i, i + count));
        }
        this.listData = newList;
        // 5秒后截停
        this.Interception = setInterval(() => {
          this.Interception2 = setInterval(() => {
            this.getdraw();
          }, 2000);
        }, 6000);
      }
    },

    // 倒计时暂停
    stop3() {
      this.state = 1;
      this.number = 5;
      this.$refs.audio1.pause();
      clearInterval(this.dao);
    },

    //开奖 （中奖名单）
    getdraw() {
      clearInterval(this.Interception2);
      // 展示名单音乐
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
        id: this.id,
      };
      this.$get(this.$axios.defaults.orURL + "/index/draw", param).then(
        (res) => {
          clearInterval(this.Interception);
          // 结束抽奖中音乐
          this.$refs.audio2.pause();
          // 中奖音乐
          this.$refs.audio4.play();
          if (res.code == 1) {
            this.zhong = setInterval(() => {
              clearInterval(this.zhong);
              this.$refs.audio4.pause();
              // 展示名单音乐
              this.$refs.audio3.play();
            }, 3000);
            this.state = 4;
            //中奖名单分页
            this.dList = res.data;
            this.nnu = 30 - res.data.length * 2;
            this.drawList = res.data.slice(0, 30); //计算一共多少页
            this.totalPage = Math.ceil(res.data.length / 30); //创建定时器，三秒钟循环一次
            this.createTimer = setInterval(() => {
              this.changeList();
            }, 5000);
          } else {
            this.state = 2;
            this.$message({
              showClose: true,
              message: res.msg,
              type: "warning",
            });
          }
        }
      );
    },
  },
  created() {
    if (this.$route.query.sy == "true") {
      this.isplaying = true;
    } else {
      this.isplaying = false;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.drawIndex();
      this.show = false;
      this.state = 4;
    } else {
      this.drawIndex();
    }
  },
  mounted: function () {
    window.addEventListener("keydown", this.handleEnter);
  },
  beforeDestroy() {
    //离开页面时清除定时器
    clearInterval(this.createTimer);
    clearInterval(this.dao);
    clearInterval(this.Interception);
    window.removeEventListener("keydown", this.handleEnter);
    // this.isplaying = true;
  },
};
</script>
  <style>
body {
  margin: 0;
  padding: 0;
}
.setImg {
  width: 90px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  margin-left: -90px;
  opacity: 0;
  /* background-color: #000; */
}

upload-img {
  width: 100%;
  height: 100%;
}
.indexs .bot {
  position: fixed;
  bottom: 0px;
  width: 100%;
  z-index: 0;
  font-size: 20px;
  margin-top: 50px;

  box-sizing: border-box;
}

/* 选择轮次 */

.zxh {
  border-bottom: 1px solid #d56926;
}

.zbox {
  width: 100%;
  height: 85px;
  padding: 0 20px;
  box-sizing: border-box;
  color: #d56926;
  border-top: 1px solid #fdc976;
}
.zhe {
  width: 100%;
  height: 100%;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #000;
}

.zheBox {
  width: 350px;
  max-height: 70vh;
  position: fixed;
  top: 15vh;
  z-index: 5;
  border-radius: 10px;
  padding-top: 20px;
  overflow-y: auto;
  background-color: #fff7e3;
}
.cc {
  align-items: center;
  justify-content: center;
  display: flex;
}

.zheBox img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
  object-fit: cover;
}

.dis_none {
  display: none;
}

.ztit {
  font-size: 18px;
  color: #d56926;
  width: 100%;
  padding-bottom: 20px;
}

/* 抽奖结果 */
.congrats {
  width: 100%;
  font-size: 30px;
  margin-top: 15px;
  padding-bottom: 15px;
  border-radius: 8px;
  color: #ec493b;
  border-bottom: 1px solid #fdc976;
}

.next {
  width: 90%;
  height: 50px;
  font-size: 16px;
  color: #ffffff;
  margin-top: -40px;
  text-align: right;
}

.cbox {
  width: 100%;
  /* height: 450px; */
}

.csma {
  width: 20%;
  height: 70px;
  padding: 15px;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  color: #fdc976;
  box-sizing: border-box;
}

/*  */
.sn-title {
  text-align: center;
}
.table-style {
  width: 100%;
  height: 35px;
  table-layout: fixed;
}
tr {
  width: 100%;
}
td:nth-child(2n) {
  background: #ffe8c3;
}
td:nth-child(4n) {
  background: #ffe8c3;
}
td {
  width: 20%;
  height: 60px;
  color: #d56926;
  font-size: 14px;
  border: 1px solid #fdc976;
}

.table {
  width: 100%;
  display: flex;
}
.seamless-warp {
  height: 420px;
  overflow: hidden;
  visibility: visible;
  background-color: #fcf2e2;
}
.seamless-warp:nth-child(2n) {
  background: #ffe8c3;
}
.seamless-warp:nth-child(2n) {
  background: #ffe8c3;
}
.colorRed {
  color: #ff4669;
}
.colorOrange {
  color: #ffc956;
}
.table-header {
}
.item {
}
tr {
}
td {
}
.title {
}
.cjing {
  font-size: 30px;
  color: #d56926;
  margin: 15px;
}

/*  */
.stop {
  cursor: pointer;
  z-index: 1;
  border-bottom: 1px solid #fff;
}
.openBot2 {
  width: 300px;
  height: 120px;
  color: #d56926;
  font-size: 50px;
  /* margin-top: 20vh; */
  cursor: pointer;
  z-index: 1;
  border-radius: 8px;
  background-color: #fdc976;
}

button {
  border: 0;
}

.num {
  font-size: 200px;
  color: #ffffff;
}

.ready {
  margin-top: 16vh;
  color: #ffffff;
}

.right .tis {
  color: #d56926;
  margin-top: 20px;
}

.indexs .gud {
  width: 90%;
  position: fixed;
  bottom: 40px;
  left: 0;
  color: #feb9b4;
  margin-left: 5%;
}

.indexs .top {
  width: 90%;
  margin-top: 80px;
}

.indexs .left {
  width: 28%;
  height: 70vh;
  color: #d56926;
  font-size: 20px;
  border-radius: 8px;
  background-color: #ffffff;
}

.left img {
  width: 95%;
  height: 70%;
  /* height: 355px; */
  margin: 10px 0 20px;
  border-radius: 8px;
  background-color: #fdc976;
}

.number {
  color: #000000;
}

.indexs .name {
  font-size: 22px;
  font-weight: bold;
  margin: 5px 0 10px;
}

.indexs .right {
  width: 70%;
  height: 70vh;
  border-radius: 14px;
  box-sizing: border-box;
  border: 10px solid#FDC976;
  background-color: #fff7e3;
}

.set1 {
  width: 90px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  color: #fcc876;
  border: 1px solid #fcc876;
}
button {
  background: none;
}

.indexs {
  width: 100%;
  min-height: 100vh;
  color: #fff;
  margin: 0;
  box-sizing: border-box;
  background-size: cover;
  /* overflow:hidden; text-overflow:ellipsis; white-space:nowrop; */
  background-image: linear-gradient(to bottom, #d93326, #ff5f52);
}

.indexs .img4 {
  width: 16px;
  height: 18px;
}

.frc {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fr {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.fcc {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.frcs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/rollName.vue